import { render, staticRenderFns } from "./AdreseLivrare.vue?vue&type=template&id=2ac3af54&scoped=true&"
import script from "./AdreseLivrare.ts?vue&type=script&lang=ts&"
export * from "./AdreseLivrare.ts?vue&type=script&lang=ts&"
import style0 from "./AdreseLivrare.vue?vue&type=style&index=0&id=2ac3af54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac3af54",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QBar from 'quasar/src/components/bar/QBar.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QBtn,QTooltip,QDialog,QCard,QBar,QSpace,QCardSection});qInstall(component, 'directives', {ClosePopup});
